const loadingReducer = (state = {
    showModal: false
}, action) => {
    switch(action.type){
        case 'SHOW_LOADING':
            return{
                ...state,
                showModal: action.payload
            }
        case 'HIDE_LOADING':
            return{
                ...state,
                showModal: action.payload
            }
        default: 
            return{
                ...state
            }
    }
}

export default loadingReducer;


// WEBPACK FOOTER //
// ./src/LoadingComponent/reducer.js